import type { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDocumentListQuery } from "web_myplann/Api/Document/useDocumentListQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { DocumentListSkeleton } from "web_myplann/Portfolio/Components/Redesign/Documents/DocumentListSkeleton";
import { EmptyFolderState } from "web_myplann/Portfolio/Components/Redesign/Documents/EmptyFolderState";
import { FolderDetailTopBar } from "web_myplann/Portfolio/Components/Redesign/Documents/FolderDetailTopBar";
import { FolderDocumentList } from "web_myplann/Portfolio/Components/Redesign/Documents/FolderDocumentList";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { useGoBack } from "web_myplann/Shared/Hooks/useGoBack";

export const FolderDetailPageRedesign: FC = () => {
	const { tag } = useParams();
	const navigate = useNavigate();
	const navigateBack = useGoBack(Routing.Portfolio.DocumentsList.path());
	const { data, isLoading } = useDocumentListQuery(tag);

	const documents = data?.documents ?? [];
	const showEmptyState = !isLoading && documents.length === 0;
	const showDocuments = !isLoading && documents.length > 0;

	const openDocumentUpload = () =>
		navigate(Routing.Portfolio.DocumentUpload.path({ folder: tag }));

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<FolderDetailTopBar
					folder={tag ?? ""}
					documentsCount={documents.length}
					onBack={navigateBack}
				/>
			}
		>
			{isLoading && <DocumentListSkeleton />}
			{showEmptyState && (
				<EmptyFolderState onAddDocument={openDocumentUpload} />
			)}
			{showDocuments && (
				<FolderDocumentList
					documents={documents}
					folder={tag}
					onAddDocument={openDocumentUpload}
				/>
			)}
		</MyPlannLayout>
	);
};
